// src/components/FilmListings/FilmListingsSection.tsx
import * as React from "react";
import Box from "@mui/material/Box";
import { ChildVenue } from "../../types/dataTypes.ts";
import { FilmTabFilters } from "../FilmTabFilters/FilmTabFilters.tsx";
import { FilmListings } from "../FilmListings/FilmListings.tsx";
import { FilmListingLoading } from "../Loading/FilmListingLoading.tsx";
import { useFilmListingsController } from "../../hooks/useFilmListingsController.ts";
import { FilmTab } from "../Tabs/FilmTab.tsx";
import { sortScreenings } from "../../helpers/componentHelpers.ts";

type Props = {
  controller: ReturnType<typeof useFilmListingsController>;
  venuesNearLocation: ChildVenue[];
  selectAllVenuesLabel: string;
  venueDistanceLabel?: string;
  containerMt?: { xs: number; md: number };
  containerMb?: { xs: number; md: number };
  forOneDay?: boolean;
};

export function FilmListingsSection({
  controller,
  venuesNearLocation,
  selectAllVenuesLabel,
  containerMt = { xs: 2, md: 0 },
  containerMb = { xs: 0, md: 0 },
  venueDistanceLabel = "away",
  forOneDay = false,
}: Props) {
  return (
    <>
      <Box
        sx={{
          width: { xs: "100%", md: "70%" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mt: containerMt,
          mb: containerMb,
        }}
      >
        <FilmTabFilters
          sortOption={controller.sortOption}
          handleSortChange={controller.handleSortChange}
          venuesNearLocation={venuesNearLocation}
          selectedVenues={controller.selectedVenues}
          onVenueToggle={controller.onVenueToggle}
          onDialogClose={controller.applyVenueSelection}
          setIsVenueModalOpen={controller.setIsVenueModalOpen}
          toggleSelectAllVenues={controller.toggleSelectAllVenues}
          selectAllVenuesLabel={selectAllVenuesLabel}
          venueDistanceLabel={venueDistanceLabel}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          mt: 3,
          mb: 1,
          justifyContent: "center",
          mx: { xs: "0%", md: "10%" },
        }}
      >
        {controller.isRefreshing ? (
          <FilmListingLoading />
        ) : forOneDay ? (
          <FilmTab
            filmData={sortScreenings(
              controller.filmsByDateRange[0].film_data,
              controller.sortOption,
            )}
            tabDateLabel={controller.filmsByDateRange[0].tab_date_label}
            sortOption={controller.sortOption}
            key={`${controller.filmsByDateRange[0].tab_date_label}_film_tab`}
            optimise={controller.optimise}
          />
        ) : (
          <FilmListings
            sortOption={controller.sortOption}
            filmsByDateRange={controller.filmsByDateRange}
            optimise={controller.optimise}
            setOptimisation={controller.setOptimisation}
          />
        )}
      </Box>
    </>
  );
}
